<template>
	<v-container
		class="space-y-lg pb-2xl first:mt-0 first:space-y-0 md:space-y-md lg:space-y-2xl"
	>
		<slot></slot>
	</v-container>
</template>

<script lang="ts" setup>
defineProps<{
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	story: any;
}>();
</script>
